export default "__VITE_ASSET__3fe7c28a__"